import { Helmet } from 'react-helmet-async';
import { Box, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import ENV from "../env";
import Logo from "../components/logo";
import LoginForm from "../components/auth/LoginForm";
import { AuthShowcase } from "../components/auth/AuthShowcase";

export default function LoginPage() {
    return (
        <>
            <Helmet>
                <title>Login | { ENV.APP_NAME }</title>
            </Helmet>

            <Box sx={ { display: 'flex', minHeight: '100vh', bgcolor: '#F4F6F8', color: '#161C24', fontFamily: (theme) => theme.typography.fontFamily } }>
                <AuthShowcase/>

                <Stack component="main" alignItems="center" justifyContent="center" spacing={ 3 } sx={ { flexGrow: 1, p: { xs: 2, sm: 6 } } }>
                    <Box sx={ { display: { xs: 'block', md: 'none' } } }><Logo/></Box>

                    <Stack component="section" spacing={ 2.5 } sx={ {
                        width: '100%', maxWidth: 420, boxSizing: 'border-box', bgcolor: '#FFFFFF', border: '1px solid #E3E8EE', borderRadius: '20px',
                        p: { xs: 3, sm: 4 },
                    } }>
                        <Stack spacing={ 0.75 }>
                            <Typography component="h1" variant="inherit" sx={ { fontSize: 28, lineHeight: '34px', fontWeight: 800, letterSpacing: '-0.02em' } }>
                                Sign in
                            </Typography>
                            <Typography sx={ { fontSize: 14, color: '#4F5B67' } }>Welcome back. Your recaps are waiting for you.</Typography>
                        </Stack>

                        <LoginForm/>

                        <Typography sx={ { fontSize: 14, textAlign: 'center', color: '#4F5B67' } }>
                            New here?{ ' ' }
                            <Link component={ RouterLink } to="/register" underline="hover" sx={ { fontWeight: 700 } }>Create a free account</Link>
                        </Typography>
                    </Stack>
                </Stack>
            </Box>
        </>
    );
}
